const snsLinks = [
  { label: "Instagram", icon: "ri-instagram-line", href: "https://www.instagram.com/granstark_security?igsh=MWxkZjM1bzZnY2JlbA==" },
  { label: "X", icon: "ri-twitter-x-line", href: "https://x.com/granstark" },
];

export default function SnsFloating() {
  return (
    <div className="fixed right-3 md:right-5 bottom-20 md:bottom-24 z-40 flex flex-col gap-3">
      {snsLinks.map((sns) => (
        <a
          key={sns.label}
          href={sns.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={sns.label}
          className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/90 text-navy flex items-center justify-center shadow-md transition-all duration-300 hover:bg-gold hover:text-navy hover:scale-110"
        >
          <span className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center">
            <i className={sns.icon}></i>
          </span>
        </a>
      ))}
    </div>
  );
}